// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__zLNEC","image":"ErrorPage_image__eqpek","title":"ErrorPage_title__IHNNn","description":"ErrorPage_description__KbkA7"};